import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/*Services */
import { StateService, ScreenService, DevicesService, AppService } from '@services';

/*Models */
import { Device, StatsTrack } from '@models';

/*Plugins */
import { IMyDrpOptions, IMyDateRangeModel } from 'mydaterangepicker';
import * as moment from 'moment';


/*Config*/
import { CONFIG } from '@config';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html'
})

export class ReportsComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private currentDevice: Device;


  myDateRangePickerOptions: IMyDrpOptions = {
    dateFormat: 'dd.mm.yyyy',
    selectBeginDateTxt: 'Выберите начало периода',
    selectEndDateTxt: 'Выберите конец периода',
    showSelectDateText: true,
    monthSelector: true,
    showClearDateRangeBtn: false,
    editableDateRangeField: false,
    openSelectorOnInputClick: true,
    showClearBtn: false,
    showApplyBtn: false,
    yearSelector: false,
    disableSince: { year: 0, month: 0, day: 0 },
    disableUntil: { year: 0, month: 0, day: 0 },
    dayLabels: CONFIG.dayLabels,
    monthLabels: CONFIG.monthLabels
  };
  modelDateRange;
  statsTrackList: Array<StatsTrack>;
  groupPEriodStatsModel = 'day';
  activeTabId = 1;
  isStarline = false;

  constructor(
    private devicesService: DevicesService,
    private stateService: StateService,
    public screenService: ScreenService,
    private appService: AppService
  ) {
    this.screenService.isDataLoadingSubject.next(true);
  }

  ngOnInit() {
    document.getElementById('sidebar-container').classList.add('info--minimal-height');
    this.screenService.isStateHidden = true;
    this.stateService.currentDeviceObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(device => {
        this.currentDevice = device;
        if(this.currentDevice.provider.toLowerCase() === "starline"){
          this.isStarline = true;
        }else{
          this.isStarline = false;
        }
        this.initDateRange();
      });
  }

  getStatistic(fromDate: number, toDate: number) {
    this.devicesService.getStatsTrack(this.currentDevice.id, fromDate, toDate)
      .subscribe(response => {
        if (response && response.length) {
          this.appService.parseDateReportsStat(response);
          this.statsTrackList = response;
          console.log(this.statsTrackList);
          this.stateService.toggleGraphStatsSubject.next(this.statsTrackList);
        } else {
          this.statsTrackList = null;
        }


        this.screenService.isDataLoadingSubject.next(false);
      }, errors => {
        this.screenService.isDataLoadingSubject.next(false);
        console.log(errors);
      });
  }



  updateListStats(statsTrackList: Array<StatsTrack>) {
   // console.log(statsTrackList);
    // const data = this.getChartsData(statsTrackList, 'distance');
    // console.log(data);
    this.stateService.toggleGraphStatsSubject.next(statsTrackList);
    // this.showChart(data);
  }



  initDateRange() {
    const date = new Date();
    const copy = this.getCopyOfOptions();

    const dateTomorrow = this.addDays(date, 1);

    copy.disableSince = {
      year: dateTomorrow.getFullYear(),
      month: dateTomorrow.getMonth() + 1,
      day: dateTomorrow.getDate(),
    };

    copy.disableUntil = {
      year: date.getFullYear() - 1,
      month: date.getMonth() + 1,
      day: date.getDate() - 1
    };

    this.myDateRangePickerOptions = copy;

    const firstDayMonth = new Date(date.getFullYear(), date.getMonth(), 1);

    this.modelDateRange = {
      beginDate: {
        year: firstDayMonth.getFullYear(),
        month: firstDayMonth.getMonth() + 1,
        day: firstDayMonth.getDate(),
      },
      endDate: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      }
    };
    this.onDateRangeChanged();
  }


  onDateRangeChanged(event?: IMyDateRangeModel) {
    if (event) {
      this.modelDateRange.beginDate = event.beginDate;
      this.modelDateRange.endDate = event.endDate;
    }

    const fromMoment = moment.utc({
      year: this.modelDateRange.beginDate.year,
      month: this.modelDateRange.beginDate.month - 1,
      date: this.modelDateRange.beginDate.day
    });

    const toMoment = moment.utc({
      year: this.modelDateRange.endDate.year,
      month: this.modelDateRange.endDate.month - 1,
      date: this.modelDateRange.endDate.day
    });

    const from = fromMoment.startOf('day').unix();
    const to = toMoment.endOf('day').unix();

    this.getStatistic(from, to);
  }

  getCopyOfOptions(): IMyDrpOptions {
    return JSON.parse(JSON.stringify(this.myDateRangePickerOptions));
  }

  addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }



  onClickTab(tabId: number){
    if(tabId==2){
      this.stateService.toggleGraphStatsSubject.next(false);
    }else{
      this.stateService.toggleGraphStatsSubject.next(this.statsTrackList);
    }
    this.activeTabId = tabId;
  }


  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    document.getElementById('sidebar-container').classList.remove('info--minimal-height');
    this.stateService.toggleGraphStatsSubject.next(false);
  }
}




// WEBPACK FOOTER //
// ./src/app/view/reports/reports.component.ts